<app-page-title [title]="id ? 'Alterar área' : 'Cadastrar área'"></app-page-title>
<div class="form-container">
  <form [formGroup]="form">
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Nome</mat-label>
      <input class="input" matInput placeholder="Nome" formControlName="description" name="description" />
      <mat-error *ngIf="form.controls.description.hasError('required')"> Obrigatório </mat-error>
    </mat-form-field>
    <br />

    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Líder</mat-label>
      <mat-select formControlName="leader_id">
        <mat-option *ngFor="let member of members" [value]="member.id">
          {{ member.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <br />

    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Igreja</mat-label>
      <mat-select formControlName="church_id">
        <mat-option *ngFor="let church of churchs" [value]="church.id">
          {{ church.description }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="form.controls.church_id.hasError('required')"> Obrigatório </mat-error>
    </mat-form-field>

    <br />

    <button *ngIf="!id" (click)="add()" mat-raised-button class="btn-primary">Cadastrar</button>

    <button *ngIf="id" (click)="save()" class="btn-primary" mat-raised-button>Salvar</button>
  </form>
</div>
